<template>
  <div>
    <el-table
      :data="testimonials.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
    >
      <el-table-column
        label="Full name"
        prop="full_name"
        sortable
      ></el-table-column>
      <el-table-column
        label="User title"
        prop="name"
        sortable
      ></el-table-column>
      <el-table-column label="Rating" prop="rating" sortable></el-table-column>
      <el-table-column label="Link" prop="link" sortable></el-table-column>
      <el-table-column
        label="Link Youtube"
        prop="link_youtube"
        sortable
      ></el-table-column>
      <el-table-column
        label="Position"
        prop="position"
        sortable
      ></el-table-column>
      <el-table-column label="Create date" prop="created_at" sortable>
        <template slot-scope="props">
          {{ props.row.created_at | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right" width="200%">
        <template slot-scope="props">
          <el-tooltip content="Edit" placement="top">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-edit"
              @click="openEdit(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="Delete" placement="top">
            <el-button
              type="danger"
              circle
              size="small"
              icon="el-icon-close"
              @click="deleteT(props.row.id)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="testimonials.current_page"
      :page-sizes="[5, 10, 25, 50, 100]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="testimonials.total"
    ></el-pagination>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('testimonial', [
      'testimonials',
      'page',
      'page_size',
      'order_column',
      'order_type'
    ])
  },

  methods: {
    ...mapActions('testimonial', ['read', 'delete']),
    ...mapMutations('testimonial', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDialog',
      'setSelectedTestimonial'
    ]),

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.read()
    },
    currentChange(page) {
      this.setPage(page)
      this.read()
    },
    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.read()
    },
    openEdit(testimonial) {
      this.setDialog(true)
      this.setSelectedTestimonial(testimonial)
    },
    deleteT(id) {
      this.$confirm(
        'You will permanently delete this testimonial. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          this.delete(id)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete cancelled'
          })
        })
    }
  },

  created() {
    this.read()
  }
}
</script>
